import cssUtil from 'gw-portals-util-js/CssUtil';

import template from 'text!./Notification.html';
import styles from './Notification-hashed.scss';

export default ['$timeout', function ($timeout) {
    return {
        restrict: 'E',
        transclude: true,
        replace: true,
        scope: {
            text: '@',
            trigger: '='
        },
        template: cssUtil.hashTemplate(template, styles),
        link: function link($scope) {
            $scope.trigger = function () {
                $timeout(function () {
                    $scope.open = true;
                    $timeout(function () {
                        $scope.open = false;
                    }, 3000);
                }, 0);
            };
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/policycommon/common/directives/schedules/MobileNotification/Notification.js
// module id = 2087
// module chunks = 0